import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class PotentialStudentsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = '/api/potentialStudents';
    return this.CommonAPIService.getCall(url, '', router);
  }

  getStudentById(userId, router) {
    const url = `/api/potentialStudents/${userId}`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  create(params, router) {
    const url = '/api/potentialStudents';
    return this.CommonAPIService.postCall(url, params, router);
  }

  delete(userId, router) {
    const url = `/api/potentialStudents/${userId}`;
    return this.CommonAPIService.deleteCall(url, '', router);
  }

  sendApplicationEmail(userId, params, router) {
    const url = `/api/potentialStudents/applicationEmail/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  sendOrientationEmail(userId, params, router) {
    const url = `/api/potentialStudents/orientationEmail/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  convertToActive(userId, router) {
    const url = `/api/potentialStudents/convertToActiveStudent/${userId}`;
    return this.CommonAPIService.putCall(url, '', router);
  }

  update(userId, params, router) {
    const url = `/api/potentialStudents/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default PotentialStudentsAPIService;
